module.exports = __webpack_public_path__ + "media/application/images/ui/wmd-buttons-834b4f42a96df567ea6cfe0b3b47c1b3.png";